import { render, staticRenderFns } from "./SimpleCitationsOverviewChart.vue?vue&type=template&id=e918d1c8&scoped=true&"
import script from "./SimpleCitationsOverviewChart.vue?vue&type=script&lang=js&"
export * from "./SimpleCitationsOverviewChart.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCitationsOverviewChart.vue?vue&type=style&index=0&id=e918d1c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e918d1c8",
  null
  
)

export default component.exports